import type { DropdownOption, FilterKey, SortKey } from "./types";

export const SORT_STORAGE_KEY = "hdg_matches_sort";
export const ANALYTICS_STORAGE_KEY = "hdg_matches_analytics";
export const PAGE_SIZE = 10;

export const SORT_OPTIONS: SortKey[] = [
  "best_match_rate",
  "nearest",
  "newest",
  "only_loves",
  "only_likes",
  "only_not_for_me",
  "online_only",
];

export const FILTER_QUERY_MAP: Record<string, FilterKey> = {
  all: "all",
  perfect: "perfect",
  loves: "loves",
  love: "loves",
  likes: "likes",
  like: "likes",
  not_for_me: "not_for_me",
  "not-for-me": "not_for_me",
  online: "online",
};

export const FILTER_MENU_OPTIONS: Array<DropdownOption<FilterKey>> = [
  { value: "all", label: "All" },
  { value: "perfect", label: "Perfect Match" },
  { value: "loves", label: "Only Loves" },
  { value: "likes", label: "Only Likes" },
  { value: "not_for_me", label: "Only Not for Me" },
  { value: "online", label: "Online Only" },
];

export const SORT_MENU_OPTIONS: Array<DropdownOption<SortKey>> = [
  { value: "best_match_rate", label: "Best Match Rate" },
  { value: "nearest", label: "Nearest" },
  { value: "newest", label: "Newest" },
  { value: "only_loves", label: "Only Loves" },
  { value: "only_likes", label: "Only Likes" },
  { value: "only_not_for_me", label: "Only Not for Me" },
  { value: "online_only", label: "Online Only" },
];

export const getBaseUrl = (): string => {
  const viteBase: string | undefined =
    typeof import.meta !== "undefined"
      ? (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL
      : undefined;
  const craBase: string | undefined =
    typeof process !== "undefined"
      ? (process as { env?: { PUBLIC_URL?: string } }).env?.PUBLIC_URL
      : undefined;
  const base = viteBase || craBase || "/";
  return base.endsWith("/") ? base : `${base}/`;
};

const RATE_ICON_BASE = `${getBaseUrl()}style_images/rate/`;
export const RATE_ICON_SRC = {
  filled: `${RATE_ICON_BASE}filled_icon.svg`,
  half: `${RATE_ICON_BASE}half_icon.svg`,
  empty: `${RATE_ICON_BASE}empty_icon.svg`,
} as const;
